export default {"src":"/_next/static/media/wind_power.646deff5.svg","height":96,"width":96,"blurWidth":0,"blurHeight":0};